export default "__VITE_ASSET__CYbmhntH__"